var pmsTabs = [
    {
        title: "All",
        eventKey: "0",
        eventCode: "0",
    },
    {
        title: "Focused",
        eventKey: "1",
        eventCode: "0",
    },
];
var ONE_LAKH_RUPEE = 100000;
var FIFTY_CRORE_RUPEE = 500000000;
var ONE_THOUSAND_CRORE_RUPEE = 10000000000;
export { pmsTabs, FIFTY_CRORE_RUPEE, ONE_THOUSAND_CRORE_RUPEE, ONE_LAKH_RUPEE };
